import React, { useState } from "react";
import api from "../../axiosConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";
export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login, token, isAuthed } = useAuth();
  
  const queryParams = React.useMemo(() => new URLSearchParams(loc.search), [loc.search]);
  const confirmed = queryParams.get("confirmed") === "true";
  const tokenFromQuery = queryParams.get("token");
  const redirectFromQuery = queryParams.get("redirect");
  const errMsgFromQuery = queryParams.get("err_msg");

  React.useEffect(() => {
    if (tokenFromQuery) {
      const companyFromQuery = queryParams.get("company");
      if (companyFromQuery) {
        localStorage.setItem("lastCompany", companyFromQuery);
      }
      login(tokenFromQuery);
    }
  }, [tokenFromQuery, queryParams, login]);

  const [company, setCompany] = useState(() => {
    const fromQuery = queryParams.get("company");
    if (fromQuery) {
      localStorage.setItem("lastCompany", fromQuery);
      return fromQuery;
    }
    return localStorage.getItem("lastCompany") || "";
  });

  const [username, setU] = useState(() => {
    return queryParams.get("username") || "alice";
  });

  const [password, setP] = useState(() => {
    const userQuery = queryParams.get("username");
    if (userQuery && userQuery !== "alice") {
      return "";
    }
    return "alice123";
  });

  const [loading, setL] = useState(false);
  const [err, setErr] = useState("");
  const [step, setStep] = useState("login"); // "login" or "2fa"
  const [code2fa, setCode2fa] = useState("");
  const [temp2faData, setTemp2faData] = useState(null);

  const isCorrectTokenLoaded = tokenFromQuery ? (token === tokenFromQuery) : isAuthed;

  if (isCorrectTokenLoaded) {
    const to = redirectFromQuery || "/";
    if (tokenFromQuery) {
      window.location.href = to;
      return null;
    }
    return <Navigate to={to} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setL(true);

    try {
      const res = await api.post(
        "/auth/login",
        {
          company,
          username,
          password,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      if (res.data?.status === "2fa_required") {
        setTemp2faData({
          user_id: res.data.user_id,
          company: res.data.company,
          username: res.data.username,
          masked_email: res.data.masked_email,
        });
        setStep("2fa");
        setL(false);
        return;
      }

      login(res.data.access_token, res.data.session_timeout_minutes);

      localStorage.setItem("lastCompany", company);

      const to = loc.state?.from?.pathname || "/";
      nav(to, { replace: true });
    } catch (e) {
      setErr(e.response?.data?.detail || "Autentificare eșuată");
    } finally {
      setL(false);
    }
  };

  const onSubmit2FA = async (e) => {
    e.preventDefault();
    setErr("");
    setL(true);

    try {
      const res = await api.post(
        "/auth/verify-2fa",
        {
          user_id: temp2faData.user_id,
          company: temp2faData.company,
          username: temp2faData.username,
          code: code2fa,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      login(res.data.access_token, res.data.session_timeout_minutes);
      localStorage.setItem("lastCompany", temp2faData.company);
      const to = loc.state?.from?.pathname || "/";
      nav(to, { replace: true });
    } catch (e) {
      setErr(e.response?.data?.detail || "Cod 2FA invalid sau expirat");
    } finally {
      setL(false);
    }
  };

  const message = loc.state?.message || "";

  if (step === "2fa") {
    return (
      <div style={{ maxWidth: 360, margin: "80px auto" }}>
        <h2>Verificare 2FA</h2>
        <div className="alert alert-info py-2 small">
          Un cod unic de verificare de 6 cifre a fost trimis la adresa de e-mail <strong>{temp2faData?.masked_email}</strong>.
        </div>
        <form onSubmit={onSubmit2FA}>
          <div className="mb-3">
            <label className="fw-semibold">Cod de verificare (6 cifre)</label>
            <input
              type="text"
              className="form-control text-center font-monospace"
              style={{ fontSize: "20px", letterSpacing: "4px" }}
              value={code2fa}
              onChange={(e) => setCode2fa(e.target.value)}
              placeholder="123456"
              maxLength={6}
              required
              autoFocus
            />
          </div>
          {err && <div className="alert alert-danger py-1">{err}</div>}
          <div className="d-flex gap-2">
            <button className="btn btn-primary flex-grow-1" disabled={loading}>
              {loading ? "Se verifică..." : "Verifică și Intră"}
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                setStep("login");
                setCode2fa("");
                setErr("");
              }}
            >
              Înapoi
            </button>
          </div>
        </form>
      </div>
    );
  }


  return (
    <div style={{ maxWidth: 360, margin: "80px auto" }}>
      <h2>Autentificare</h2>
      {message && <div className="alert alert-success py-2">{message}</div>}
      {errMsgFromQuery === "already_confirmed" && (
        <div className="alert alert-info py-2 small mb-3">
          Contul a fost deja activat. Te rugăm să te conectezi folosind parola aleasă.
        </div>
      )}
      <form onSubmit={onSubmit}>
        <div className="mb-3">
          <label>Firmă (cod / CUI)</label>
          <input
            type="text"
            className="form-control"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
          <small className="text-muted">
            Introdu codul firmei (ex: ALFA) sau CUI.
          </small>
        </div>
        <div className="mb-2">
          <label>Utilizator</label>
          <input
            className="form-control"
            value={username}
            onChange={(e) => setU(e.target.value)}
            autoFocus
          />
        </div>
        <div className="mb-2">
          <label>Parola</label>
          <input
            className="form-control"
            type="password"
            value={password}
            onChange={(e) => setP(e.target.value)}
          />
        </div>
        {err && <div className="alert alert-danger py-1">{err}</div>}
        <button className="btn btn-primary" disabled={loading}>
          {loading ? "Se conectează..." : "Intră"}
        </button>

        {/* <Link to="/register">Creează cont</Link> */}
        <button
          type="button"
          className="btn btn-link"
          onClick={() => nav("/register")}
        >
          Creează firmă
        </button>
      </form>
    </div>
  );
}
